import Salaries from "../components/Salary/Salaries";
import Salary from "../components/Salary/Salary";
import {PERM} from "../utilites/permissions";

const salaries = [
  {
    path: '/salaries',
    name: 'Salaries',
    component: Salaries,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
      ]
    },
    props: true,
  },
  {
    path: '/salaries/new',
    name: 'SalaryAdd',
    component: Salary,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
        PERM.STAFF_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/salaries/edit/:id',
    name: 'SalaryEdit',
    component: Salary,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
        PERM.STAFF_EDIT,
      ]
    },
    props: true
  },
];

export default salaries;



// WEBPACK FOOTER //
// ./src/router/salaries.js